import { Close } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import { TextFieldStyles } from "../../styles/commonStyles";
import FormActionButton from "../buttons/formActionButton.component";
import { useState } from "react";
import UnderlineButton from "../buttons/underlineButton.component";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { updateSensorStart } from "../../store/features/customer/sensor/sensorSlice";

const SensorDialog = ({ open, onClose, field, accessToken, onSensorAdded }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedSensor, setSelectedSensor] = useState("");
  const [, setIsSensorFirstTimeAdded] = useState(false);

  const unassignedSensors = useSelector(
    (state) => state.sensors?.unassigned?.data
  );

  const handleSensorChange = (e) => {
    setSelectedSensor(e.target.value);
  };
  const handleAddSensor = () => {
    const sensor = unassignedSensors.find(
      (sensor) => sensor.sensor_type === selectedSensor
    );
    const updatedData = {
      field: field.id,
      devEUI: sensor.devEUI,
      appEUI: sensor.appEUI,
      nickname: sensor.nickname,
      appKey: sensor.appKey,
      sensor_type: sensor.sensor_type.id,
      update_frequency: sensor.update_frequency,
    };
    setIsSensorFirstTimeAdded(true);
    dispatch(
      updateSensorStart({
        data: updatedData,
        sensorId: sensor.id,
        accessToken: accessToken,
      })
    );

    onSensorAdded?.(true);
  };

  return (
    <Dialog
      open={open}
      aria-labelledby="sensor-dialog"
      aria-describedby="add new sensor"
      maxWidth="lg"
      slotProps={{
        paper: {
          sx: {
            width: "391px",
            height: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 2,
          },
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={() => ({
          position: "absolute",
          right: 8,
          top: 8,
        })}
      >
        <Close sx={{ width: "20px", height: "20px", color: "text.primary" }} />
      </IconButton>
      <DialogTitle
        id="sensor-dialog-title"
        sx={{ fontWeight: "bold", fontSize: "20px" }}
      >
        Aggiungi sensore
      </DialogTitle>
      <DialogContent>
        {unassignedSensors?.length > 0 ? (
          <DialogContentText
            id="subArea-dialog-description"
            sx={{ fontSize: "14px" }}
          >
            Puoi sceglierlo dalla lista dei tuoi sensori. Non lo hai ancora
            aggiunto?{""}
            <UnderlineButton
              label="Aggiungi sensore"
              onClick={() => navigate("/tools/addTool")}
            />
          </DialogContentText>
        ) : (
          <DialogContentText
            id="subArea-dialog-description"
            sx={{
              fontSize: "14px",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            Non hai ancora sensori disponibili. Aggiungine uno per poterlo
            collegare a questo terreno.
            <FormActionButton
              label="Aggiungi sensore"
              onClick={() => navigate("/tools/addTool")}
            />
          </DialogContentText>
        )}

        {unassignedSensors?.length > 0 && (
          <Box display="flex" flexDirection="column" gap={6} mt={3}>
            <TextField
              variant="filled"
              id="sensor"
              label="Sensore"
              fullWidth
              sx={TextFieldStyles}
              select
              onChange={handleSensorChange}
              value={selectedSensor}
              disabled={unassignedSensors?.length === 0}
            >
              {unassignedSensors && unassignedSensors.length > 0 ? (
                unassignedSensors.map((option) => (
                  <MenuItem key={option.id} value={option.sensor_type}>
                    {option.nickname}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>
                  <em>Seleziona un sensore</em>
                </MenuItem>
              )}
            </TextField>
            <FormActionButton
              label="Aggiungi sensore"
              style={{
                width: "100%",
                textTransform: "none",
                borderRadius: "2px",
              }}
              disabled={!selectedSensor}
              onClick={handleAddSensor}
            />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SensorDialog;
